import { DataTable, Spinner } from "@src/components/ui-kit";
import { withCan } from "@src/utils/components/permissions";
import { useStore } from "@src/utils/hooks";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import {
  BannerNotMySheet,
  BannerPastTimerRunning,
  DayMode,
  NavBar,
  WeekMode,
} from "./components";
import { useFetchTimeTrackingItems, useFetchUsers } from "./hooks";
import { Store, StoreContext } from "./store";
import s from "./styles.module.css";

export const TimeSheet = withCan(
  {
    do: [
      "timeTracking_read_all",
      "timeTracking_read_team",
      "timeTracking_read_own",
    ],
  },
  observer(function TimeSheet() {
    const appStore = useStore();
    const [store] = useState(() => new Store(appStore));

    useEffect(() => {
      const timeout = 30 * 1000; // 30sec
      const timer = setInterval(() => store.stepper.refreshCurrent(), timeout);
      return () => clearInterval(timer);
    }, []);

    useFetchUsers(store);
    useFetchTimeTrackingItems(store);

    if (store.timeTrackingItemsLoading && !store.summaryPerDay.length) {
      return <Spinner absolute />;
    }

    return (
      <StoreContext.Provider value={store}>
        <div className={s.TimeSheet}>
          {!store.weekMode && (
            <BannerPastTimerRunning
              runningDate={store.runningTimerDate}
              currentDate={store.stepper.current}
              onAction={(date) => {
                store.stepper.setCurrent(date);
                store.weekMode && store.toggleWeekMode(false);
              }}
            />
          )}
          <BannerNotMySheet
            meId={store.appStore.authStore.user!.id}
            currentUser={store.currentUser}
            onAction={() =>
              store.userId.onChange(store.appStore.authStore.user!.id)
            }
          />
          <DataTable>
            <NavBar />
            {store.weekMode ? <WeekMode /> : <DayMode />}
          </DataTable>
        </div>
      </StoreContext.Provider>
    );
  }),
);
